import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaLock, FaEnvelope, FaEye, FaEyeSlash, FaArrowLeft, FaShieldAlt } from "react-icons/fa";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    setTimeout(() => {
      const formattedEmail = email.trim().toLowerCase();
      // Validate credentials
      if (
        (formattedEmail === "parthadebnath161@gmail.com" || formattedEmail === "partha161@gmail.com") &&
        password === "Partha@2001"
      ) {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userEmail", email);
        setLoading(false);
        navigate("/admin");
      } else {
        setLoading(false);
        setError("Invalid email or password. Please try again.");
      }
    }, 600);
  };

  return (
    <div className="min-h-screen w-full bg-[#0F172A] text-slate-100 flex flex-col justify-center items-center px-6 relative overflow-hidden font-sans">
      {/* Background Orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#00B4DB]/12 rounded-full blur-[140px] pointer-events-none" />

      {/* Back to Home Button */}
      <Link
        to="/"
        className="absolute top-8 left-8 flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-[#00B4DB] transition-colors bg-[#1E293B] border border-slate-700 px-4 py-2 rounded-xl backdrop-blur-md shadow-sm"
      >
        <FaArrowLeft size={14} /> Back to Portfolio
      </Link>

      {/* Login Card */}
      <div className="w-full max-w-md bg-[#1E293B]/90 border border-slate-700/80 p-8 sm:p-10 rounded-3xl shadow-2xl relative z-10 hover:border-[#00B4DB]/40 transition-colors">
        
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-blue-600 via-sky-600 to-[#00B4DB] flex items-center justify-center text-white shadow-md shadow-blue-500/25 font-bold">
            <FaShieldAlt size={26} />
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-white">
            Admin <span className="gradient-text">Portal</span>
          </h1>
          <p className="text-slate-400 text-xs sm:text-sm mt-1.5">
            Log in to access your portfolio dashboard
          </p>
        </div>

        {/* Error Alert */}
        {error && (
          <div className="mb-6 p-4 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 text-xs font-semibold text-center">
            ⚠️ {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-6">
          {/* Email Input */}
          <div>
            <label className="block text-slate-300 text-xs font-semibold uppercase tracking-wider mb-2 flex items-center gap-2">
              <FaEnvelope className="text-[#00B4DB]" /> Email ID
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              className="w-full px-4 py-3.5 rounded-xl bg-[#0F172A] text-white font-medium placeholder:text-slate-500 text-sm border border-slate-700 focus:border-[#00B4DB] focus:ring-2 focus:ring-[#00B4DB]/20 outline-none transition-all"
            />
          </div>

          {/* Password Input */}
          <div>
            <label className="block text-slate-300 text-xs font-semibold uppercase tracking-wider mb-2 flex items-center gap-2">
              <FaLock className="text-[#00B4DB]" /> Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
                className="w-full px-4 py-3.5 pr-12 rounded-xl bg-[#0F172A] text-white font-medium placeholder:text-slate-500 text-sm border border-slate-700 focus:border-[#00B4DB] focus:ring-2 focus:ring-[#00B4DB]/20 outline-none transition-all"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition-colors"
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-xl bg-gradient-to-r from-blue-600 via-sky-600 to-[#00B4DB] text-white font-extrabold text-sm hover:opacity-95 shadow-md shadow-blue-500/25 transition-all flex items-center justify-center gap-2 transform hover:-translate-y-0.5 disabled:opacity-50"
          >
            {loading ? "Authenticating..." : "Sign In to Dashboard"}
          </button>
        </form>

        <div className="mt-8 text-center border-t border-slate-700/80 pt-6 text-xs text-slate-400">
          🔒 Secure Admin Authentication Area
        </div>
      </div>
    </div>
  );
};

export default Login;
